import { getThemeProductDetailSupport } from "../../Core/Support/GetThemeProductDetailSupport";
import { CuratorialSegmentCombination } from "../../Core/Combination/CuratorialSegmentCombination";

/***
 * 取得各主題產品資訊
 ***/
export function SheetHotelProductService() {

  // 取回分類後的各主題 "區域名稱", "產品" 陣列
  let _getHotelSegmentDetail = async (google_spread_id, flagship_sheets_list) => {
    let theme_product_list = await _getThemeHotelDetail(google_spread_id, flagship_sheets_list);
    let HotelSegment = await CuratorialSegmentCombination().classifyHotelOriginDataBySegmentName(theme_product_list);

    return HotelSegment;
  }
  
  // 取得 sheet 表單各主題旅館原始資料
  let _getThemeHotelDetail = async function (spread_id, flagship_sheets_list) {
    let theme_hotel_detail_list = await getThemeProductDetailSupport(
      spread_id,
      flagship_sheets_list
    );
    return theme_hotel_detail_list;
  };

  return {
    getThemeHotelDetail: _getThemeHotelDetail,
    getHotelSegmentDetail: _getHotelSegmentDetail
  };
}
